// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__28y7d","inner":"Link_inner__2yezk"};